// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import useAutoLogout from '../hooks/useAutoLogout';

function getUser() {
  try {
    return JSON.parse(localStorage.getItem('currentUser') || 'null');
  } catch (_) {
    return null;
  }
}

function getRole(user) {
  const raw = (user?.role || user?.userType || user?.type || user?.account_type || '').toString().toLowerCase();
  if (raw) return raw;
  if (user?.isAdmin === true) return 'admin';
  return '';
}

function isAdminUser(user) {
  const role = getRole(user);
  return role === 'admin' || role === 'association' || role === 'aaapd' || role === 'superadmin' || user?.isAdmin === true;
}

const ProtectedRouteBase = ({ children, requireAdmin = false, timeoutMinutes = 30, redirectPath = '/login' }) => {
  // Initialize auto-logout functionality (idle timeout)
  useAutoLogout(timeoutMinutes, redirectPath);

  const currentUser = getUser();
  const loggedIn = !!currentUser && (currentUser.id != null || currentUser.email);

  // Must be logged in
  if (!loggedIn) {
    return <Navigate to={redirectPath} replace />;
  }

  // If admin required, validate role
  if (requireAdmin && !isAdminUser(currentUser)) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

// OPD routes: require authentication; role check is lenient (any logged-in user)
export const OPDProtectedRoute = ({ children }) => (
  <ProtectedRouteBase timeoutMinutes={30} redirectPath="/login">
    {children}
  </ProtectedRouteBase>
);

// Admin routes: require authentication + admin-like role
export const AdminProtectedRoute = ({ children }) => (
  <ProtectedRouteBase timeoutMinutes={30} redirectPath="/login" requireAdmin>
    {children}
  </ProtectedRouteBase>
);

export default ProtectedRouteBase;
